import { eventChannel } from 'redux-saga';
import { visibilityChange } from './actions';

/* eslint-disable import/prefer-default-export */
export const visibilityChangeChannel = () => eventChannel(emitter => {
  const visibilityChangeHandler = document.addEventListener('visibilitychange', () => (
    emitter(visibilityChange(document.hidden))
  ));

  return () => {
    document.removeEventListener('visibilitychange', visibilityChangeHandler);
  };
});
/* eslint-enable import/prefer-default-export */
